import * as Sentry from '@sentry/react';

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const APP_ENV = process.env.REACT_APP_APP_ENV || 'development';

export function initSentry() {
  if (!SENTRY_DSN) {
    console.warn('Sentry DSN not configured. Error tracking is disabled.');
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: APP_ENV,

    // 성능 모니터링 샘플링 비율 (10%)
    tracesSampleRate: 0.1,

    // 세션 리플레이 샘플링 (1%)
    replaysSessionSampleRate: 0.01,
    // 에러 발생 시 세션 리플레이 샘플링 (100%)
    replaysOnErrorSampleRate: 1.0,

    // 브라우저 트레이싱 통합
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // 개발 환경에서는 에러를 콘솔에도 출력
    debug: APP_ENV === 'development',

    // 민감한 정보 필터링
    beforeSend(event) {
      // 개인정보 보호를 위해 사용자 IP 제거
      if (event.user) {
        delete event.user.ip_address;
      }
      return event;
    },
  });

  console.log(`Sentry initialized for environment: ${APP_ENV}`);
}

// 사용자 정보 설정 (로그인 후 호출)
export function setSentryUser(user: { id: string; email?: string }) {
  Sentry.setUser(user);
}

// 사용자 정보 제거 (로그아웃 시 호출)
export function clearSentryUser() {
  Sentry.setUser(null);
}

// 커스텀 에러 캡처
export function captureError(error: Error, context?: Record<string, unknown>) {
  if (context) {
    Sentry.setContext('additional', context);
  }
  Sentry.captureException(error);
}

// 커스텀 메시지 캡처
export function captureMessage(message: string, level: Sentry.SeverityLevel = 'info') {
  Sentry.captureMessage(message, { level });
}

export { Sentry };
